module.exports = __webpack_public_path__ + "static/media/ML Meet-Up.95640759.png";